import React from 'react';
import { Modal } from 'react-bootstrap';
import ProcessNominas from './ProcessNominas';
const RowsNominas = ({ nominas, show, onHide }) => {
    return (
        <Modal size="lg" centered show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Imprimir nominas</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProcessNominas nominas={nominas} />
            </Modal.Body>
        </Modal>
    );
};

export default RowsNominas;
